/* CILSON – Warenkorb v2: Texte, Staffel-Hinweise, Lieferbox, Gutschein einklappbar */
(() => {
  if (window.cilsonCartV2) return;
  window.cilsonCartV2 = true;

  const eur = (v) => v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  let tiers = {};
  try { tiers = JSON.parse((document.getElementById('cil-cart-tiers') || {}).textContent || '{}'); } catch (e) {}

  const setText = (el, txt) => { if (el && el.textContent !== txt) el.textContent = txt; };

  // Titel ohne " | CILSON", "Weiter einkaufen"
  const texts = () => {
    document.querySelectorAll('cart-items .cart-item__name').forEach((a) => {
      const t = a.textContent.replace(/\s*\|\s*CILSON\s*$/i, '');
      setText(a, t);
    });
    const link = document.querySelector('cart-items .title-wrapper-with-link a');
    if (link && /shoppen/i.test(link.textContent)) link.textContent = 'Weiter einkaufen';
  };

  // Staffel-Hinweis: "Noch 1 St. bis 16,00 € / St." (antippen setzt die Menge)
  const tierHints = () => {
    document.querySelectorAll('cart-items .cart-item').forEach((row) => {
      const input = row.querySelector('.quantity__input');
      const details = row.querySelector('.cart-item__quantity') || row.querySelector('.cart-item__details');
      if (!input || !details) return;
      const data = tiers[input.dataset.quantityVariantId];
      const list = data && Array.isArray(data.t)
        ? data.t.filter((x) => x && x.min > 0 && x.p > 0).sort((a, b) => a.min - b.min) : [];
      const qty = parseInt(input.value, 10) || 0;
      const next = list.find((x) => x.min > qty);
      let btn = details.querySelector('.cil-tier-up');
      if (!next) { if (btn) btn.remove(); return; }
      const key = next.min + ':' + qty;
      if (btn && btn.dataset.key === key) return;
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cil-tier-up';
        details.appendChild(btn);
        btn.addEventListener('click', () => {
          const inp = row.querySelector('.quantity__input');
          const min = parseInt(btn.dataset.min, 10);
          if (!inp || !min) return;
          inp.value = min;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      const diff = next.min - qty;
      btn.dataset.key = key;
      btn.dataset.min = next.min;
      btn.innerHTML = 'Noch ' + diff + ' St. bis <b>' + eur(next.p) + ' / St.</b><span>– jetzt auf ' + next.min + ' St. erhöhen</span>';
      btn.setAttribute('aria-label', 'Menge auf ' + next.min + ' Stück erhöhen, Staffelpreis ' + eur(next.p) + ' pro Stück');
    });
  };

  // Stückpreis-Zeile auf dem Handy unter den Produktnamen
  const lineInfo = () => {
    document.querySelectorAll('cart-items .cart-item').forEach((row) => {
      const src = row.querySelector('.cart-item__totals .cil-line-info');
      const name = row.querySelector('.cart-item__name');
      if (!src || !name) return;
      let m = row.querySelector('.cil-line-info-m');
      if (!m) { m = document.createElement('div'); m.className = 'cil-line-info-m'; name.insertAdjacentElement('afterend', m); }
      if (m.innerHTML !== src.innerHTML) m.innerHTML = src.innerHTML;
    });
  };

  // DHL-Hinweis in die Lieferbox
  let dhl = null;
  const shipBox = () => {
    const fs = document.querySelector('#main-cart-footer .cil-fs');
    if (!dhl) dhl = document.querySelector('#main-cart-footer .cil-dhl');
    if (fs && dhl && dhl.parentElement !== fs) fs.appendChild(dhl);
  };

  // "Gesamt: 8 Stück = 16 m" -> "8 Stück (16 m)"; Steuerhinweis nicht doppelt
  const totals = () => {
    const ct = document.querySelector('#main-cart-footer .cil-ct');
    if (ct) {
      const h = ct.innerHTML;
      const n = h.replace(/Gesamt:\s*<b>([^<]+)<\/b>\s*=\s*<b>([^<]+)<\/b>/, '<b>$1</b> ($2)');
      if (n !== h) ct.innerHTML = n;
    }
    const tax = document.querySelector('#main-cart-footer .tax-note');
    if (tax) tax.childNodes.forEach((node) => {
      if (node.nodeType === 3 && /Inklusive Steuern\.?/i.test(node.textContent)) {
        node.textContent = node.textContent.replace(/Inklusive Steuern\.?\s*/i, '');
      }
    });
  };

  // Zur Kasse mit Schloss-Symbol
  const checkout = () => {
    const b = document.querySelector('#main-cart-footer .cart__checkout-button');
    if (!b || b.querySelector('.cil-lock')) return;
    b.insertAdjacentHTML('afterbegin', '<svg class="cil-lock" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>');
    b.style.display = 'flex'; b.style.alignItems = 'center'; b.style.justifyContent = 'center';
  };

  // Gutschein & Anmerkung einklappbar
  const collapsibles = () => {
    const vc = document.querySelector('#main-cart-footer .cil-vc');
    if (vc && !vc.dataset.cil) {
      const label = vc.querySelector(':scope > label');
      const input = vc.querySelector('input');
      if (label) {
        vc.dataset.cil = '1';
        label.textContent = 'Gutscheincode eingeben';
        label.setAttribute('role', 'button');
        label.setAttribute('tabindex', '0');
        const msg = vc.querySelector('.cil-vc-msg');
        const open = (input && input.value) || (msg && msg.offsetParent && msg.textContent.trim());
        vc.classList.toggle('zu', !open);
        label.setAttribute('aria-expanded', String(!!open));
        const toggle = (e) => {
          e.preventDefault();
          const zu = vc.classList.toggle('zu');
          label.setAttribute('aria-expanded', String(!zu));
          if (!zu && input) input.focus();
        };
        label.addEventListener('click', toggle);
        label.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') toggle(e); });
      }
    }
    const note = document.querySelector('#main-cart-footer .cil-note');
    if (note && !note.dataset.cil) {
      const s = note.querySelector('summary');
      if (s) { note.dataset.cil = '1'; s.textContent = 'Anmerkung zur Bestellung (optional)'; }
      const ta = note.querySelector('textarea');
      if (ta) ta.placeholder = 'z. B. Lieferhinweise, Ansprechpartner, Bestellnummer';
    }
  };

  const run = () => { texts(); lineInfo(); tierHints(); shipBox(); totals(); checkout(); collapsibles(); };

  let t;
  const schedule = () => { clearTimeout(t); t = setTimeout(run, 50); };
  const start = () => {
    run();
    [300, 900, 2000].forEach((ms) => setTimeout(run, ms));
    const main = document.getElementById('MainContent') || document.body;
    new MutationObserver(schedule).observe(main, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', (e) => { if (e.target.matches && e.target.matches('cart-items .quantity__input')) schedule(); }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
